export class CashRegisterVendorSettings {
  vatRateDepartmentMapping?: { [key: string]: number };

  constructor() {
    this.vatRateDepartmentMapping = {};
  }
}

